import handleQueryError from '../../../../util/Common/Error/Handler/handleQueryError';
import safetyDefaultAPI from '../../api';

const getAccident = async ({ seq }) => {
  try {
    const response = await safetyDefaultAPI.get(`accident/${seq}`);
    return response;
  } catch (error) {
    throw new Error(handleQueryError({ error }));
  }
};

export default getAccident;
